// Curated icon palette for CMS "icon" fields. Firestore can only store a
// string, not a component, so icon fields store one of these keys and the
// renderer/editor both resolve it through this map. Covers every icon
// already used by the sections this CMS makes editable (ExquraWhyBook,
// and the About Us / Contact Us sections planned for a later phase) —
// extend this list (and re-export the new lucide import) when a new block
// type needs an icon that isn't here yet.
import {
  Shield,
  Flag,
  Zap,
  Headphones,
  Globe,
  Lock,
  Trophy,
  Leaf,
  Users,
  Mail,
  Phone,
  MapPin,
  Clock,
  Star,
  FileText,
  CalendarCheck,
  CircleHelp,
  Briefcase,
} from "lucide-react";

export const ICONS = {
  Shield,
  Flag,
  Zap,
  Headphones,
  Globe,
  Lock,
  Trophy,
  Leaf,
  Users,
  Mail,
  Phone,
  MapPin,
  Clock,
  Star,
  FileText,
  CalendarCheck,
  CircleHelp,
  Briefcase,
};

export const ICON_NAMES = Object.keys(ICONS);

/** Resolves a stored icon name to its component, falling back to Star for
 * any unrecognized/legacy value so a block never renders with no icon at all. */
export function resolveIcon(name) {
  return ICONS[name] || Star;
}
